import script from "./Balance.vue?vue&type=script&setup=true&lang=js"
export * from "./Balance.vue?vue&type=script&setup=true&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=9113b310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9113b310"]])

export default __exports__